/**
 * Typed client for FiltersHandler.ashx.
 *
 * The backend still expects the legacy filter state and SQL-like query string.
 * Keep that compatibility detail here instead of spreading it across UI code.
 */
import type {
  FilterResult,
  FiltersState,
  FormStatusItem,
  SavedFilter,
  SubmissionStatus
} from '../models/filter';
import { actionUrl, request } from './http';

export async function applyFilters(state: FiltersState, query: string): Promise<FilterResult | null> {
  return request<FilterResult | null>(actionUrl('FiltersHandler', 'ApplyFilters'), {
    method: 'POST',
    body: {
      FormID: state.FormID,
      StartDate: state.StartDate,
      EndDate: state.EndDate,
      Query: query,
      Columns: state.Columns,
      PageSize: state.PageSize,
      PageIndex: state.PageIndex,
      Order: state.Order,
      Status: state.Status
    }
  });
}

export async function getFiltersList(formId: number): Promise<SavedFilter[]> {
  return request<SavedFilter[]>(actionUrl('FiltersHandler', 'GetFiltersList', { FormID: formId }), { method: 'POST' });
}

export async function getFilter(filterId: number): Promise<SavedFilter> {
  return request<SavedFilter>(actionUrl('FiltersHandler', 'GetFilter', { FilterID: filterId }), { method: 'POST' });
}

export async function addFilter(formId: number, name: string, state: FiltersState): Promise<void> {
  await request(actionUrl('FiltersHandler', 'AddFilter'), { method: 'POST', body: { FormID: formId, Name: name, Filters: JSON.stringify(state) } });
}

export async function updateFilter(filterId: number, name: string, state: FiltersState): Promise<void> {
  await request(actionUrl('FiltersHandler', 'UpdateFilter'), { method: 'POST', body: { ReportId: filterId, Name: name, Filters: JSON.stringify(state) } });
}

export async function removeFilter(filterId: number): Promise<void> {
  await request(actionUrl('FiltersHandler', 'RemoveFilter', { FilterID: filterId }), { method: 'POST' });
}

export async function getStatusList(formId: number): Promise<FormStatusItem[]> {
  return request<FormStatusItem[]>(actionUrl('FiltersHandler', 'GetStatusList', { FormID: formId }), { method: 'POST' });
}

export async function getSubmittedFormStatus(submittedFormId: number): Promise<SubmissionStatus> {
  return request<SubmissionStatus>(actionUrl('FiltersHandler', 'GetSubmittedFormStatus', { SubmittedFormId: submittedFormId }), { method: 'POST' });
}

export async function applyNewStatus(submittedFormId: number, selectedStatus: number[], statusText: string): Promise<void> {
  await request(actionUrl('FiltersHandler', 'ApplyNewStatus'), {
    method: 'POST',
    body: { SubmittedFormId: submittedFormId, SelectedStatus: selectedStatus, StatusText: statusText }
  });
}

export function getExcelUrl(state: FiltersState): string {
  return actionUrl('FiltersHandler', 'GetExcel', { FormID: state.FormID, StartDate: state.StartDate, EndDate: state.EndDate });
}
